import * as tokens from '@utmost.co/utmost-design-tokens';
import { ITokenVars } from '@utmost.co/utmost-design-tokens';

export function tokenToPx(tokenName: TokenName): string | undefined {
  return varToUnit(tokenName, 'px');
}

export function tokenWithOpacity(tokenName: TokenName, opacity: `${number}%`, baseColor = 'transparent'): string {
  return `color-mix(in srgb, ${tokens[tokenName]} ${opacity}, ${baseColor})`;
}

export function token(tokenName: TokenName): string | undefined {
  if (typeof tokens[tokenName] !== 'string') {
    return undefined;
  }
  return tokens[tokenName];
}

function varToUnit(tokenName: TokenName, unit: 'px'): string | undefined {
  if (!tokens[tokenName] || typeof tokens[tokenName] !== 'string') {
    return undefined;
  }
  const value = tokens[tokenName];
  if (!value.includes('var(--')) {
    return value;
  }
  return `calc(${value} * 1${unit})`;
}

type TokenName = keyof Omit<ITokenVars, 'source'>;
